<template>
  <div
    class="uk-section uk-section-secondary uk-padding-remove-top uk-padding-remove-bottom uk-position-bottom"
    style="z-index: 2;position: fixed !important;"
  >
    <div class="uk-container">
      <div class="uk-flex uk-flex-between uk-flex-middle">
        <div>
          <button class="uk-button uk-button-default uk-button-small">
            Tambah Keranjang
          </button>
        </div>
        <div>
          <button class="uk-button uk-button-default uk-button-small">
            Beli Sekarang
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: "NavbarMobileComponent"
};
</script>

<style>
</style>